// extracted by mini-css-extract-plugin
export default {"mailToolbar":"qMFkiVQiVAczkLmFxGR6","panelMailButtons":"vYri0WYzZ0bNYZBsDHLv","btnMail":"J8A_fp7DwanBuKjmbxe2","disabled":"_tsdl4HGS1AnmNIwGBdh"};